import { call, put, takeLatest } from "redux-saga/effects";
import { fetchAllDepartments } from "../../../services/department";
import {
  getDepartmentsStart,
  getDepartmentsFailure,
  getDepartmentsSuccess,
} from "../reducer";

export function* getAllDepartments({ payload }) {
  const response = yield call(fetchAllDepartments, payload);
  const { success, raw, message } = response;

  if (success) {
    yield put(getDepartmentsSuccess(raw));
  } else {
    yield put(getDepartmentsFailure(message || raw.error));
  }
}

export default function* onGetAllDepartments() {
  yield takeLatest(getDepartmentsStart.type, getAllDepartments);
}
